import React, { } from "react";
import { Modal, Box, Typography, Stack, Button } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { collectionsActions } from "../../store";
import { removeCollection, fetchCollectionsData } from "../../services/collectionServices";
import { useNavigate } from "react-router-dom";

const RemoveCollectionModal = () => {
    const dispatch = useDispatch();
    const removeCollectionModal = useSelector((state) => state.collections.removeCollectionModal);
    const selectedCollectionId = useSelector((state) => state.collections.collectionMenuSelectedCollectionId);
    const navigate = useNavigate();
    const theme = useTheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: theme.palette.surface1.main,
        color: theme.palette.surface1.contrastText,
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const removeCollectionHandler = async () => {
        try {
            dispatch(collectionsActions.setLoader({ value: true }));
            await removeCollection(selectedCollectionId);
            const response = await fetchCollectionsData();
            dispatch(collectionsActions.setCollections({ collections: response.data.collections }));
            dispatch(collectionsActions.setLoader({ value: false }));
            dispatch(collectionsActions.setSnackbar({ value: { open: true, type: 'success', message: 'Collection removed successfully !!!' } }));
            dispatch(collectionsActions.setRemoveCollectionModalClose());
        }
        catch (error) {
            dispatch(collectionsActions.setLoader({ value: false }));
            console.log(error.response);
            dispatch(collectionsActions.setSnackbar({ value: { open: true, type: 'error', message: error?.response?.statusText || error.toString() } }));
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={removeCollectionModal}
            onClose={() => dispatch(collectionsActions.setRemoveCollectionModalClose())}
        >
            <Box sx={style}>
                <Stack rowGap={3}>
                    <Typography variant="h5">Remove Collection?</Typography>
                    <Typography>Projects in the collection will be moved to the “Uncollected projects” card.</Typography>
                    <Stack direction="row" justifyContent="flex-end" columnGap={3}>
                        <Button onClick={() => dispatch(collectionsActions.setRemoveCollectionModalClose())}>Cancel</Button>
                        <Button onClick={removeCollectionHandler}>Yes, Remove</Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
}

export default RemoveCollectionModal;